// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__01OR_","header":"style_header__B_7nh"};